import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { USER } from "../../constants/constant";
import { _axios } from "../../plugins/axios";
import CallCustomer from "./callCustomer";
import { decrptor, maskingAdhaar, maskPassportVID } from "./regex";

class DependantHeaderSample extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: USER.user,
      orderStatus: null,
      headerDetails: this.props.orderHeader,
      titleCall: this.props.titleCall,
      title: this.props.title,
      showPopUp: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    this.setState({ headerDetails: this.props.orderHeader });
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps !== this.props) {
      return true;
    } else return false;
  }

  formatDate(date) {
    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    return date.getDate() + "-" + months[date.getMonth()] + "-" + date.getFullYear();
  }

  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }

  hideRescheduleModal() {
    console.log("This is Closed");
    this.setState({
      showPopUp: false,
    });
  }
  
  getAge(birthDate) {
     return Math.floor((new Date() - new Date(birthDate).getTime()) / 3.15576e+10);
  }

  render() {
    return (
      <div className="header-sample-without-radius">
        {this.state.titleCall ? (
          <Container>
            <Row>
              <Col xs={9} md={9} className="margin-auto">
                <div className="font-size-ml bold">{this.state.title ? this.state.title : ""}</div>
              </Col>
              <Col xs={3} md={3} className="text-align-right m-t-10">
                {this.props.noCall ? "" : <CallCustomer></CallCustomer>}
              </Col>
            </Row>
          </Container>
        ) : (
          <Container>
            <Row>
              <Col md={6} xs={12}>
                <div>
                  <b>
                    Order Status:{" "}
                    <span className={`font-color-${this.state.headerDetails.orderStatus.currentStatusId}`}>
                      {this.state.headerDetails.orderStatus.statusMessage}
                    </span>
                  </b>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={8} md={8} className="text-align-left margin-auto">
                <div className="p-t-20">
                  <b className="font-size-md">Patient Details</b>
                </div>
                <span className="font-size-smd">
                  <b>Patient: </b>
                  {this.state.headerDetails.patientDetails[0].name +
                    " (Age: " +
                    (this.state.headerDetails.patientDetails[0].patientAge != null ? this.state.headerDetails.patientDetails[0].patientAge : this.getAge(this.state.headerDetails.patientDetails[0].patientDOB)) +
                    ", Gender: " +
                    (this.state.headerDetails.patientDetails[0].patientGender != null
                      ? this.state.headerDetails.patientDetails[0].patientGender
                      : "NA") +
                    ")"}
                </span>
                {typeof this.state.headerDetails.patientDetails[0].employeeId == "string" &&
                this.state.headerDetails.patientDetails[0].employeeId != "" ? (
                  <div className="font-size-smd width-100">
                    <b>Emp/PNO :</b> {this.state.headerDetails.patientDetails[0].employeeId}
                  </div>
                ) : (
                  ""
                )}
                {typeof this.state.headerDetails.patientDetails[0].corporateName == "string" &&
                this.state.headerDetails.patientDetails[0].corporateName != "" ? (
                  <div className="font-size-smd width-100">
                    <b>Corporate :</b> {this.state.headerDetails.patientDetails[0].corporateName}
                  </div>
                ) : (
                  ""
                )}
                {this.props.noCall ? (
                  ""
                ) : typeof this.state.headerDetails.patientDetails[0].phoneNumber == "string" &&
                  this.state.headerDetails.patientDetails[0].phoneNumber != "" ? (
                  <div className="font-size-smd width-100">
                    <b>Customer Ph # :</b> {this.state.headerDetails.patientDetails[0].phoneNumber}
                  </div>
                ) : (
                  ""
                )}
              </Col>
              <Col xs={4} md={4} className="text-align-right p-t-30">
                {this.props.noCall ? "" : <CallCustomer></CallCustomer>}
              </Col>
            </Row>
            <div className="font-size-smd bold">
              <i className="fa fa-map-marker m-r-10 p-b-10" aria-hidden="true"></i>
              Customer Address
            </div>
            <div className="font-size-smd">
              {this.state.headerDetails.patientDetails[0].addressLine1 ? (
                <span> {this.state.headerDetails.patientDetails[0].addressLine1}, </span>
              ) : (
                ""
              )}
              {this.state.headerDetails.patientDetails[0].addressLine2 ? (
                <span> {this.state.headerDetails.patientDetails[0].addressLine2}, </span>
              ) : (
                ""
              )}
              {this.state.headerDetails.patientDetails[0].landmark} - {this.state.headerDetails.patientDetails[0].pincode}
            </div>

            <Row>
              <Col md={6} className="text-align-left">
                {typeof this.state.headerDetails.patientDetails[0].priority == "string" &&
                this.state.headerDetails.patientDetails[0].priority != "" ? (
                  <div className="font-size-md width-100">
                    <b>Priority : </b>
                    {this.state.headerDetails.patientDetails[0].priority}
                  </div>
                ) : (
                  ""
                )}
              </Col>
            </Row>

            <Row>
              <Col md={10} sm={10} xs={10} className="text-align-left">
                <div className="font-size-smd width-100">
                  <b>Aadhaar No:</b>{" "}
                  {decrptor(this.state.headerDetails.patientDetails[0].aadharNumber)
                    ? maskingAdhaar(decrptor(this.state.headerDetails.patientDetails[0].aadharNumber))
                    : "NA"}
                </div>
              </Col>
              {decrptor(this.state.headerDetails.patientDetails[0].passPort) && (
                <Col md={10} sm={10} xs={10} className="text-align-left">
                  <div className="font-size-smd width-100">
                    <b>Passport No / Voter ID:</b>{" "}
                    {decrptor(this.state.headerDetails.patientDetails[0].passPort)
                      ? maskPassportVID(decrptor(this.state.headerDetails.patientDetails[0].passPort))
                      : "NA"}
                  </div>
                </Col>
              )}
              <Col md={2} sm={2} xs={2} className="text-align-right position-relative">
                {[4].includes(this.state.headerDetails.orderStatus.currentStatusId) && (
                  <button
                    type="button"
                    className="btn btn-default btn-sm patientEdit"
                    onClick={() => this.props.onEditCustomer(this.state.headerDetails)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-pencil-square"
                      viewBox="0 0 16 16"
                    >
                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                      <path
                        fill-rule="evenodd"
                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                      />
                    </svg>
                  </button>
                )}
              </Col>
            </Row>
            <div className="p-t-20">
              <b className="font-size-md">Appointment Details</b>
            </div>

            {[2, 3, 33, 4].includes(this.state.headerDetails.orderStatus.currentStatusId) && (
              <Row>
                <Col xs={7} md={7} className="text-align-left">
                  <div className="font-size-smd">
                    <span className="p-b-10 width-100 bold">Dependant ID: </span>
                    <span className="p-b-15">{this.state.headerDetails.dependantId ? this.state.headerDetails.dependantId : "NA"}</span>
                  </div>
                  <div className="font-size-smd">
                    <span className="p-b-10 width-100 bold">Order ID: </span>
                    <span className="p-b-15">{this.state.headerDetails.prOrderId}</span>
                  </div>
                  <div className="p-b-10 font-size-smd">
                    <b>Appointment Time: </b>
                    {this.formatDate(new Date(this.state.headerDetails.orderDateTime))}{" "}
                    {this.formatAMPM(new Date(this.state.headerDetails.orderDateTime))}
                    <br />
                  </div>
                </Col>
                <Col xs={5} md={5} className="text-align-right">
                  <div className="font-size-md bold">
                    <button
                      type="button"
                      className="btn btn-outline-primary width-100 border-curve-10 mt-2"
                      onClick={() => {
                        this.props.onRescheduleRoute(
                          this.state.headerDetails.orderId,
                          this.state.headerDetails.orderDateTime,
                          this.state.headerDetails.appointmentId,
                          this.state.headerDetails.patientDetails[0].city,
                          this.state.headerDetails.dependantId,
                          this.state.headerDetails.prOrderId,
                          this.state.headerDetails.patientDetails[0].name
                        );
                      }}
                    >
                      Reschedule
                    </button>
                  </div>
                </Col>
              </Row>
            )}
            <Row>
              {![2, 3, 33, 4].includes(this.state.headerDetails.orderStatus.currentStatusId) && (
                <Col xs={12} md={12}>
                    <div className="font-size-smd">
                    <span className="p-b-10 width-100 bold">Dependant ID: </span>
                    <span className="p-b-15">{this.state.headerDetails.dependantId ? this.state.headerDetails.dependantId : "NA"}</span>
                  </div>
                  <div className="font-size-smd">
                    <span className="p-b-10 width-100 bold">Order ID: </span>
                    <span className="p-b-15">{this.state.headerDetails.prOrderId}</span>
                  </div>
                  <div className="p-b-10 font-size-smd">
                    <b>Appointment Time: </b>
                    {this.formatDate(new Date(this.state.headerDetails.orderDateTime))}{" "}
                    {this.formatAMPM(new Date(this.state.headerDetails.orderDateTime))}
                    <br />
                  </div>
                </Col>
              )}
            </Row>

            {/* { this.state.headerDetails.isEligibleForSponsoredAHC && (
              <div className="width-100 text-center text-danger">
                <b>Family AHC Pending</b>
              </div>
            )} */}
          </Container>
        )}
      </div>
    );
  }
}
export default DependantHeaderSample;
